export default __webpack_public_path__ + "static/media/welcome-image.32e2abb4.png";